import { useParams } from 'react-router';

import type { Policy } from '@cartwhl/common/appletPolicy';

import CanvasLayout from '../CanvasLayout';
import CanvasLayoutAccessDenied from '../CanvasLayout/CanvasLayoutAccessDenied';
import CanvasLayoutLoading from '../CanvasLayout/CanvasLayoutLoading';
import MotionEditorCreateSceneRoute from './components/MotionEditorCreateSceneRoute';
import MotionEditorWithPlayer from './components/MotionEditorWithPlayer';
import { KeyPoseProvider } from './keyPoses';
import { withProvider as withProviderMotionEditorStore } from './motionEditorStore';
import { RepathingProvider } from './repathing';

function MotionEditorRoute() {
  const { motionID } = useParams<{ motionID?: string }>();

  if (motionID) {
    return <MotionEditorCreateSceneRoute />;
  }

  return <MotionEditorWithPlayer />;
}

function MotionEditorRouteWithKeyPoses() {
  return (
    <KeyPoseProvider>
      <RepathingProvider>
        <MotionEditorRoute />
      </RepathingProvider>
    </KeyPoseProvider>
  );
}

const MotionEditorWithStore = withProviderMotionEditorStore(
  MotionEditorRouteWithKeyPoses,
);

const applet = {
  id: 'motion-editor',
  path: '/motion-editor',
  paths: [
    '/motion-viewer',
    '/motion-viewer/create/:motionID',
    '/motion-viewer/:sceneID',
    '/motion-editor',
    '/motion-editor/create/:motionID',
    '/motion-editor/:sceneID',
  ],
  label: 'Motion Editor',
  description: 'Generative editing and reshaping.',
  dashboard: {
    badge: 'New',
    videoSrc:
      'https://resources.getcartwheel.com/share/demo-videos/05_motion_editor_dashboard_output.webm',
    title: 'Motion Editor',
    description: 'Generative editing and reshaping.',
    order: 25,
  },
  policy: {
    requiresAdmin: false,
    requiresApiKey: 'soft',
  } satisfies Policy,
  component: MotionEditorWithStore,
  layout: CanvasLayout,
  loading: CanvasLayoutLoading,
  accessDenied: CanvasLayoutAccessDenied,
};

export default applet;
